import {
  TREQUEST_EDIT_LEARNING_CURVE_ORDER_EFFICIENCY,
  TREQUEST_EDIT_ORDER_DETAILS_HEADER,
  TREQUEST_ORDER_DETAILS_HEADER,
  TREQUEST_ORDER_DETAILS_LEARNING_CURVE,
  TREQUEST_ORDER_DETAILS_PLANNING_CARD,
  TWithoutPlanVersion,
  TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES,
  TRESPONSE_ORDER_DETAILS_HEADER,
  TRESPONSE_ORDER_DETAILS_LEARNING_CURVE,
  TRESPONSE_ORDER_DETAILS_PLANNING_CARD,
  TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE,
  TRESPONSE_ORDER_ALLOCATION_CARD_DATA,
  TRESPONSE_PO_DETAILS_CARD,
  TRESPONSE_PO_DETAILS_COLOR_SIZE,
  TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA,
  TREQUEST_DEFAULT_COUNT_EDIT_ORDER_DETAILS,
  TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID,
  TRESPONSE_ORDER_TIMELINE_CARD_DATA,
  TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TOrderDetailsActionType } from './order-details.models';
import { TLiftedFormModel } from '@monorepo/ui';

export class SetIsSyncEnabled implements Action {
  readonly type = TOrderDetailsActionType.SetIsSyncEnabled;
  constructor(public syncEnabled: boolean) {}
}

export class SetPlanningCardLoader implements Action {
  readonly type = TOrderDetailsActionType.SetPlanningCardLoader;
  constructor(public showLoader: boolean) {}
}

export class ClearPlanningCardDetails implements Action {
  readonly type = TOrderDetailsActionType.ClearPlanningCardDetails;
  constructor() {}
}

export class GetPlanningCard implements Action {
  readonly type = TOrderDetailsActionType.GetPlanningCard;
  constructor(
    public payload: TWithoutPlanVersion<TREQUEST_ORDER_DETAILS_PLANNING_CARD>,
    public destination: 'LL_BOARD' | 'ORDER_DETAILS',
  ) {}
}

export class GetPlanningCardSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetPlanningCardSuccess;
  constructor(public planningCardRes: TRESPONSE_ORDER_DETAILS_PLANNING_CARD) {}
}

export class GetPlanningCardFailure implements Action {
  readonly type = TOrderDetailsActionType.GetPlanningCardFailure;
  constructor() {}
}

export class SetLearningCurveCardLoader implements Action {
  readonly type = TOrderDetailsActionType.SetLearningCurveCardLoader;
  constructor(public showLoader: boolean) {}
}

export class ClearlearningCurveCardDetails implements Action {
  readonly type = TOrderDetailsActionType.ClearlearningCurveCardDetails;
  constructor() {}
}

export class GetLearningCurveCard implements Action {
  readonly type = TOrderDetailsActionType.GetLearningCurveCard;
  constructor(public payload: TREQUEST_ORDER_DETAILS_LEARNING_CURVE) {}
}

export class GetLearningCurveCardSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetLearningCurveCardSuccess;
  constructor(public learningCurveCardRes: TRESPONSE_ORDER_DETAILS_LEARNING_CURVE) {}
}

export class GetLearningCurveCardFailure implements Action {
  readonly type = TOrderDetailsActionType.GetLearningCurveCardFailure;
}

export class SetShowAllLearningCurvesLoader implements Action {
  readonly type = TOrderDetailsActionType.SetShowAllLearningCurvesLoader;
  constructor(public showLoader: boolean) {}
}

export class GetAllLearningCurves implements Action {
  readonly type = TOrderDetailsActionType.GetAllLearningCurves;
  constructor(public localLoader?: boolean) {}
}

export class GetAllLearningCurvesSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetAllLearningCurvesSuccess;
  constructor(public learningCurves: TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES) {}
}

export class GetAllLearningCurvesFailure implements Action {
  readonly type = TOrderDetailsActionType.GetAllLearningCurvesFailure;
}

export class GetViewLearningCurveModal implements Action {
  readonly type = TOrderDetailsActionType.GetViewLearningCurveModal;
  constructor(public learningCurveId: string) {}
}

export class GetViewLearningCurveModalSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetViewLearningCurveModalSuccess;
  constructor(public viewLearningCurveRes: TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE) {}
}

export class GetViewLearningCurveModalFailure implements Action {
  readonly type = TOrderDetailsActionType.GetViewLearningCurveModalFailure;
  constructor() {}
}

export class EditLearningCurveOrderEfficiency implements Action {
  readonly type = TOrderDetailsActionType.EditLearningCurveOrderEfficiency;
  constructor(
    public editPayload: TREQUEST_EDIT_LEARNING_CURVE_ORDER_EFFICIENCY,
    public fetchPayload: TREQUEST_ORDER_DETAILS_LEARNING_CURVE,
  ) {}
}

export class EditLearningCurveOrderEfficiencySuccess implements Action {
  readonly type = TOrderDetailsActionType.EditLearningCurveOrderEfficiencySuccess;
  constructor() {}
}

export class EditLearningCurveOrderEfficiencyFailure implements Action {
  readonly type = TOrderDetailsActionType.EditLearningCurveOrderEfficiencyFailure;
  constructor() {}
}

export class SetHeaderLoader implements Action {
  readonly type = TOrderDetailsActionType.SetHeaderLoader;
  constructor(public showLoader: boolean) {}
}

export class GetHeader implements Action {
  readonly type = TOrderDetailsActionType.GetHeader;
  constructor(public payload: TREQUEST_ORDER_DETAILS_HEADER) {}
}

export class GetHeaderSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetHeaderSuccess;
  constructor(public headerRes: TRESPONSE_ORDER_DETAILS_HEADER) {}
}

export class GetHeaderFailure implements Action {
  readonly type = TOrderDetailsActionType.GetHeaderFailure;
  constructor() {}
}

export class EditHeader implements Action {
  readonly type = TOrderDetailsActionType.EditHeader;
  constructor(public editPayload: TREQUEST_EDIT_ORDER_DETAILS_HEADER) {}
}
export class EditHeaderSuccess implements Action {
  readonly type = TOrderDetailsActionType.EditHeaderSuccess;
  constructor() {}
}
export class EditHeaderFailure implements Action {
  readonly type = TOrderDetailsActionType.EditHeaderFailure;
  constructor() {}
}

export class EditDefaultCount implements Action {
  readonly type = TOrderDetailsActionType.EditDefaultCount;
  constructor(public editPayload: TREQUEST_DEFAULT_COUNT_EDIT_ORDER_DETAILS) {}
}
export class EditDefaultCountSuccess implements Action {
  readonly type = TOrderDetailsActionType.EditDefaultCountSuccess;
  constructor() {}
}
export class EditDefaultCountFailure implements Action {
  readonly type = TOrderDetailsActionType.EditDefaultCountFailure;
  constructor() {}
}

export class SetPoDetailsLoader implements Action {
  readonly type = TOrderDetailsActionType.SetPoDetailsLoader;
  constructor(public showLoader: boolean) {}
}

export class SetProcessMappingDetailsLoader implements Action {
  readonly type = TOrderDetailsActionType.SetProcessMappingDetailsLoader;
  constructor(public showLoader: boolean) {}
}

export class ClearPoCardDetails implements Action {
  readonly type = TOrderDetailsActionType.ClearPoCardDetails;
  constructor() {}
}

export class GetPoDetailsCard implements Action {
  readonly type = TOrderDetailsActionType.GetPoDetailsCard;
  constructor(public poDetailsReq: TLiftedFormModel['payload']) {}
}

export class GetPoDetailsCardSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetPoDetailsCardSuccess;
  constructor(public poDetailsCardRes: TRESPONSE_PO_DETAILS_CARD) {}
}

export class GetPoDetailsCardFailure implements Action {
  readonly type = TOrderDetailsActionType.GetPoDetailsCardFailure;
}

export class FetchProcessMappingDetailsCard implements Action {
  readonly type = TOrderDetailsActionType.FetchProcessMappingDetailsCard;
  constructor(public otlId: string) {}
}
export class FetchProcessMappingDetailsCardSuccess implements Action {
  readonly type = TOrderDetailsActionType.FetchProcessMappingDetailsCardSuccess;
  constructor(public payload: TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID) {}
}
export class FetchProcessMappingDetailsCardFailure implements Action {
  readonly type = TOrderDetailsActionType.FetchProcessMappingDetailsCardFailure;
  constructor() {}
}

export class AddUpdatePoDetailsOrder implements Action {
  readonly type = TOrderDetailsActionType.AddUpdatePoDetailsOrder;
  constructor(public updatePoDetailsOrderReq: TLiftedFormModel['payload']) {}
}

export class AddUpdatePoDetailsOrderSuccess implements Action {
  readonly type = TOrderDetailsActionType.AddUpdatePoDetailsOrderSuccess;
}

export class AddUpdatePoDetailsOrderFailure implements Action {
  readonly type = TOrderDetailsActionType.AddUpdatePoDetailsOrderFailure;
}

export class DeletePoDetailsOrder implements Action {
  readonly type = TOrderDetailsActionType.DeletePoDetailsOrder;
  constructor(public deletePoDetailsOrderReq: TLiftedFormModel['payload']) {}
}

export class DeletePoDetailsOrderSuccess implements Action {
  readonly type = TOrderDetailsActionType.DeletePoDetailsOrderSuccess;
}

export class DeletePoDetailsOrderFailure implements Action {
  readonly type = TOrderDetailsActionType.DeletePoDetailsOrderFailure;
}

export class GetPoColorSizeQtyDetails implements Action {
  readonly type = TOrderDetailsActionType.GetPoColorSizeQtyDetails;
  constructor(public poColorSizeReq: TLiftedFormModel['payload']) {}
}

export class GetPoColorSizeQtyDetailsSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetPoColorSizeQtyDetailsuccess;
  constructor(public poColorSizeQtyRes: TRESPONSE_PO_DETAILS_COLOR_SIZE) {}
}

export class GetPoColorSizeQtyDetailsFailure implements Action {
  readonly type = TOrderDetailsActionType.GetPoColorSizeQtyDetailsFailure;
}

export class UpdatePoColorQtyByRatio implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorQtyByRatio;
  constructor(public updateColorQtyByRatioReq: TLiftedFormModel['payload']) {}
}

export class UpdatePoColorQtyByRatioSuccess implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorQtyByRatioSuccess;
}

export class UpdatePoColorQtyByRatioFailure implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorQtyByRatioFailure;
}
export class UpdatePoColorSizeQtyManually implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorSizeQtyManually;
  constructor(public updatePoColorSizeQtyManualReq: TLiftedFormModel['payload']) {}
}

export class UpdatePoColorSizeQtyManuallySuccess implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorSizeQtyManuallySuccess;
}

export class UpdatePoColorSizeQtyManuallyFailure implements Action {
  readonly type = TOrderDetailsActionType.UpdatePoColorSizeQtyManuallyFailure;
}

export class SetOrderAllocationLoader implements Action {
  readonly type = TOrderDetailsActionType.SetOrderAllocationLoader;
  constructor(public showLoader: boolean) {}
}

export class ClearAllocationCardDetails implements Action {
  readonly type = TOrderDetailsActionType.ClearAllocationCardDetails;
  constructor() {}
}

export class GetAllocationCardDetails implements Action {
  readonly type = TOrderDetailsActionType.GetAllocationCardDetails;
  constructor(public otlId: string) {}
}

export class GetAllocationCardDetailsSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetAllocationCardDetailsuccess;
  constructor(public allocationCardInfoRes: TRESPONSE_ORDER_ALLOCATION_CARD_DATA) {}
}

export class GetAllocationCardDetailsFailure implements Action {
  readonly type = TOrderDetailsActionType.GetAllocationCardDetailsFailure;
}

export class SetOrderTimelineLoader implements Action {
  readonly type = TOrderDetailsActionType.SetOrderTimelineLoader;
  constructor(public showLoader: boolean) {}
}

export class GetOrderTimelineCardDetails implements Action {
  readonly type = TOrderDetailsActionType.GetOrderTimelineCardDetails;
  constructor(public otlId: string) {}
}

export class GetOrderTimelineCardDetailsSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetOrderTimelineCardDetailsSuccess;
  constructor(public payload: TRESPONSE_ORDER_TIMELINE_CARD_DATA) {}
}

export class GetOrderTimelineCardDetailsFailure implements Action {
  readonly type = TOrderDetailsActionType.GetOrderTimelineCardDetailsFailure;
}

export class SetLinewisePlannedQtyLoader implements Action {
  readonly type = TOrderDetailsActionType.SetLinewisePlannedQtyLoader;
  constructor(public showLoader: boolean) {}
}

export class GetLinewisePlannedQtyCardDetails implements Action {
  readonly type = TOrderDetailsActionType.GetLinewisePlannedQtyCardDetails;
  constructor(public otlId: string) {}
}

export class GetLinewisePlannedQtyCardDetailsSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetLinewisePlannedQtyCardDetailsSuccess;
  constructor(public payload: TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA) {}
}

export class GetLinewisePlannedQtyCardDetailsFailure implements Action {
  readonly type = TOrderDetailsActionType.GetLinewisePlannedQtyCardDetailsFailure;
}

export class SetOperationBreakdownDetailsLoader implements Action {
  readonly type = TOrderDetailsActionType.SetOperationBreakdownDetailsLoader;
  constructor(public showLoader: boolean) {}
}

export class GetOperationBreakdownDetails implements Action {
  readonly type = TOrderDetailsActionType.GetOperationBreakdownDetails;
  constructor(public otlId: string) {}
}

export class GetOperationBreakdownDetailsSuccess implements Action {
  readonly type = TOrderDetailsActionType.GetOperationBreakdownDetailsSuccess;
  constructor(public payload: TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA) {}
}

export class GetOperationBreakdownDetailsFailure implements Action {
  readonly type = TOrderDetailsActionType.GetOperationBreakdownDetailsFailure;
}

export type TOrderDetailsAction =
  | SetIsSyncEnabled
  | SetPlanningCardLoader
  | ClearPlanningCardDetails
  | GetPlanningCard
  | GetPlanningCardSuccess
  | GetPlanningCardFailure
  | SetHeaderLoader
  | GetHeader
  | GetHeaderSuccess
  | GetHeaderFailure
  | EditHeader
  | EditHeaderSuccess
  | EditHeaderFailure
  | SetLearningCurveCardLoader
  | ClearlearningCurveCardDetails
  | GetLearningCurveCard
  | GetLearningCurveCardSuccess
  | GetLearningCurveCardFailure
  | SetShowAllLearningCurvesLoader
  | GetAllLearningCurves
  | GetAllLearningCurvesFailure
  | GetAllLearningCurvesSuccess
  | EditLearningCurveOrderEfficiency
  | EditLearningCurveOrderEfficiencyFailure
  | EditLearningCurveOrderEfficiencySuccess
  | GetViewLearningCurveModal
  | GetViewLearningCurveModalFailure
  | GetViewLearningCurveModalSuccess
  | SetPoDetailsLoader
  | SetProcessMappingDetailsLoader
  | ClearPoCardDetails
  | GetPoDetailsCard
  | FetchProcessMappingDetailsCard
  | FetchProcessMappingDetailsCardSuccess
  | FetchProcessMappingDetailsCardFailure
  | GetPoDetailsCardSuccess
  | GetPoDetailsCardFailure
  | AddUpdatePoDetailsOrder
  | AddUpdatePoDetailsOrderSuccess
  | AddUpdatePoDetailsOrderFailure
  | DeletePoDetailsOrder
  | DeletePoDetailsOrderSuccess
  | DeletePoDetailsOrderFailure
  | GetPoColorSizeQtyDetails
  | GetPoColorSizeQtyDetailsSuccess
  | GetPoColorSizeQtyDetailsFailure
  | UpdatePoColorQtyByRatio
  | UpdatePoColorQtyByRatioSuccess
  | UpdatePoColorQtyByRatioFailure
  | UpdatePoColorSizeQtyManually
  | UpdatePoColorSizeQtyManuallySuccess
  | UpdatePoColorSizeQtyManuallyFailure
  | SetOrderAllocationLoader
  | ClearAllocationCardDetails
  | GetAllocationCardDetails
  | GetAllocationCardDetailsSuccess
  | GetAllocationCardDetailsFailure
  | SetOperationBreakdownDetailsLoader
  | GetOperationBreakdownDetails
  | GetOperationBreakdownDetailsSuccess
  | GetOperationBreakdownDetailsFailure
  | SetOrderTimelineLoader
  | GetOrderTimelineCardDetails
  | GetOrderTimelineCardDetailsSuccess
  | GetOrderTimelineCardDetailsFailure
  | SetLinewisePlannedQtyLoader
  | GetLinewisePlannedQtyCardDetails
  | GetLinewisePlannedQtyCardDetailsSuccess
  | GetLinewisePlannedQtyCardDetailsFailure;
